module.exports = __webpack_public_path__ + "static/media/dashboradEmpty.716a8537.svg";